export const Image = ({ src, alt, className}) => {
    // const baseUrl = "";
    //Storybook
    // const baseUrl = "https://localhost:44360/";
    const baseUrl = "";
    return <img src={baseUrl + src} alt={alt} className={className} />;
};